import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-a9b6291a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manage-forms-container" }
const _hoisted_2 = { class: "text-left font-weight-black checkbox-cell" }
const _hoisted_3 = { class: "text-left font-weight-black" }
const _hoisted_4 = { class: "text-left font-weight-black" }
const _hoisted_5 = {
  key: 0,
  class: "text-left font-weight-black"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-left font-weight-black" }
const _hoisted_8 = { class: "text-left font-weight-black" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-left font-weight-black" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "text-left font-weight-black"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = {
  key: 0,
  class: "action-buttons-container text-right"
}
const _hoisted_14 = { class: "edit-device-btn-container" }
const _hoisted_15 = { class: "delete-device-btn-container" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "no-hover" }
const _hoisted_18 = {
  colspan: "4",
  class: "text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentContainerNavbar = _resolveComponent("ContentContainerNavbar")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_DeleteDeviceModal = _resolveComponent("DeleteDeviceModal")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ContentContainerNavbar, {
        title: _ctx.$t('i18n.manageFormsTitle', { records: _ctx.filteredForms().length }),
        button: !_ctx.$vuetify.display.smAndDown,
        buttonText: _ctx.$t('i18n.createForm'),
        buttonEvent: "create-form-btn",
        onCreateFormBtn: _ctx.goToCreateFormContainer
      }, null, 8, ["title", "button", "buttonText", "onCreateFormBtn"]),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
            key: 0,
            type: "table"
          }))
        : (_openBlock(), _createBlock(_component_v_table, {
            key: 1,
            class: "table",
            "fixed-header": "",
            hover: _ctx.formDeviceAssociationList.length !== 0
          }, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_2, [
                    _createVNode(_component_v_icon, {
                      class: "cursor-pointer pr-6",
                      icon: _ctx.filterActive ? 'mdi-filter-remove' : 'mdi-filter-menu',
                      onClick: _ctx.toggleFilter
                    }, null, 8, ["icon", "onClick"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('i18n.name')), 1)
                  ]),
                  _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('i18n.description')), 1),
                  _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('i18n.associatedDevices')), 1),
                  (!_ctx.$vuetify.display.smAndDown)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.filterActive)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                      _createElementVNode("th", _hoisted_7, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.filters.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.name) = $event)),
                          density: "compact",
                          variant: "outlined",
                          "hide-details": true,
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("th", _hoisted_8, [
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.filters.description,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.description) = $event)),
                          density: "compact",
                          variant: "outlined",
                          "hide-details": true,
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _hoisted_9,
                      (!_ctx.$vuetify.display.smAndDown)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_10))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.formDeviceAssociationList.length !== 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredForms(), (form, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "text-left",
                        key: form.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(form.name), 1),
                        _createElementVNode("td", null, _toDisplayString(form.description), 1),
                        _createElementVNode("td", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.associated_devices, (device) => {
                            return (_openBlock(), _createBlock(_component_v_chip, {
                              variant: "flat",
                              key: device.id,
                              class: "ma-2 gorate-bg cursor-pointer",
                              label: "",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToDevice()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(device.name), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        (!_ctx.$vuetify.display.smAndDown)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_v_btn, {
                                  class: "mr-3 cursor-pointer",
                                  variant: "text",
                                  icon: "",
                                  onClick: ($event: any) => (_ctx.editForm(form.id))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      class: "cursor-pointer",
                                      size: "large",
                                      icon: "$GoRateEdit"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_v_btn, {
                                  class: "cursor-pointer",
                                  variant: "text",
                                  icon: "",
                                  onClick: ($event: any) => (_ctx.openDeleteFormModal(index)),
                                  disabled: _ctx.formDeletionDisabled(index)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      size: "small",
                                      icon: "$GoRateDeleteOutline"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "disabled"]),
                                (_ctx.formDeletionDisabled(index))
                                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                      key: 0,
                                      activator: "parent",
                                      location: "start"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.getDeleteBtnTooltipText(index)), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                    _createElementVNode("tr", _hoisted_17, [
                      _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.$t('i18n.noFormsAvailable')), 1)
                    ])
                  ]))
            ]),
            _: 1
          }, 8, ["hover"]))
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.deleteFormModalIsActive,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.deleteFormModalIsActive) = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DeleteDeviceModal, {
          formID: _ctx.selectedFormID,
          onCloseModal: _ctx.closeDeleteFormModal
        }, null, 8, ["formID", "onCloseModal"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}